module.exports = __webpack_public_path__ + "static/media/easi6_en.aa6d5398.md";


//////////////////
// WEBPACK FOOTER
// ./src/policies/easi6_en.md
// module id = 53
// module chunks = 0